(() => {
  if (document.documentElement.lang !== 'de') return;
  const translate = () => {
    document.querySelectorAll('.swatch-option-name').forEach(label => {
      const labels = { Peso: 'Gewicht', Calibro: 'Fruchtgröße' };
      const translated = labels[label.textContent.trim()];
      if (translated) label.textContent = translated;
    });
  };
  translate();
  new MutationObserver(translate).observe(document.body, { childList: true, subtree: true });
})();
